<app-header></app-header>
<div class="content small-head">

  <mat-card appearance="outlined" class="info-card">
    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="lang-btns" value="pl">
      <mat-button-toggle mat-icon-button aria-label="Polski" value="pl" (click)="setLang('pl-PL')">
        <div class="flag-wrapper">
          <div class="flag flag-icon-background flag-icon-pl"></div>
        </div>
        <span>Polski</span>
      </mat-button-toggle>
      <mat-button-toggle mat-icon-button color="primary" aria-label="English" value="en" (click)="setLang('en-GB')">
        <div class="flag-wrapper">
          <div class="flag flag-icon-background flag-icon-gb"></div>
        </div>
        <span>English</span>
      </mat-button-toggle>
      <mat-button-toggle mat-icon-button color="primary" aria-label="French" value="de" (click)="setLang('fr-FR')">
        <div class="flag-wrapper">
          <div class="flag flag-icon-background flag-icon-fr"></div>
        </div>
        <span>Français</span>
      </mat-button-toggle>
    </mat-button-toggle-group>
    <h3>{{'LoginTitle' | translate }}</h3>
    <form [formGroup]="loginForm" class="standard-form" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="fill">
        <mat-label>{{'Login' | translate }}</mat-label>
        <input matInput formControlName="login" [errorStateMatcher]="matcher" placeholder="Wprowadź imię...">
        @if (loginForm.controls['login'].hasError('minlength') && !loginForm.controls['login'].hasError('required')) {
          <mat-error>
            {{'FieldRequiredMoreThanTwoChar' | translate }}
          </mat-error>
        }
        @if (loginForm.controls['login'].hasError('required')) {
          <mat-error [innerHtml]="'FieldRequired' | translate">
          </mat-error>
        }
      </mat-form-field>
      <br>
        <mat-form-field appearance="fill">
          <mat-label>{{'Password' | translate }}</mat-label>
          <input matInput type="password" formControlName="password" placeholder="Wprowadź nazwisko...">
          @if (loginForm.controls['password'].hasError('minlength') && !loginForm.controls['password'].hasError('required')) {
            <mat-error>
              {{'FieldRequiredMoreThanFiveChar' | translate }}
            </mat-error>
          }
          @if (loginForm.controls['password'].hasError('required')) {
            <mat-error [innerHtml]="'FieldRequired' | translate">
            </mat-error>
          }
        </mat-form-field>
        <br>
          <br>
            <div class="form-btn-wrapper">
              <button mat-raised-button color="primary" type="submit" [disabled]="!loginForm.valid">
                @if (loading) {
                  <span class="spinner-border spinner-border-sm mr-1"></span>
                }
                {{'Next' | translate }}
              </button>
            </div>
          </form>
        </mat-card>
      </div>